var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserCompany ? _c('v-btn', {
    staticClass: "mt-10",
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-phone-cancel ")]), _c('span', [_vm._v(" 종료하기 ")])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }